import { withForm } from '@components/ui/form/form';
import { detailsIntelSchema } from '@schemas/company.schema';
import { DEFAULT_COUNTRY, countries, usStates } from '@utils/constants';
import { companyFormOptions } from './company-form-options';

const stateOptions = usStates.map((state) => ({
  label: `${state.name} (${state.code})`,
  value: state.code,
}));

// AZ-451 D9: Details step for admin-created Intelligence orgs — only the org-general fields
// (Name + Description + Location). No logo, year-founded, CMMC, SAMS UEI, or government-work fields.
// Wrapped in <form.AppForm> so the pre-bound field components resolve the form context (the innovator
// DetailsStep provides that wrapper; the admin branch renders this section directly).
export const DetailsIntelSection = withForm({
  ...companyFormOptions,
  render: function Render(props) {
    const { form } = props;

    return (
      <form.AppForm>
        <div className="flex w-full flex-col items-start gap-6">
          <form.AppField
            name="name"
            validators={{
              onBlur: detailsIntelSchema.shape.name,
            }}
          >
            {(field) => (
              <field.TextField
                autoComplete="off"
                data-1p-ignore
                label="Name"
                placeholder="Organization name"
                required
                type="text"
              />
            )}
          </form.AppField>

          <form.AppField
            name="description"
            validators={{
              onBlur: detailsIntelSchema.shape.description,
            }}
          >
            {(field) => (
              <field.TextAreaField
                label="Description"
                placeholder="A short description of this organization"
                textareaClassName="flex h-28 w-full rounded-lg bg-gray-100 p-3"
              />
            )}
          </form.AppField>

          <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3">
            <form.AppField
              listeners={{
                onChange: () => {
                  const currentCountry = form.getFieldValue('country');
                  if (currentCountry && currentCountry !== DEFAULT_COUNTRY) {
                    form.setFieldValue('city', '');
                    form.setFieldValue('state', '');
                  }
                },
              }}
              name="country"
              validators={{
                onChange: detailsIntelSchema.shape.country,
              }}
            >
              {(field) => (
                <field.SelectPopoverField
                  className="w-full"
                  emptyMessage="No country found"
                  formatValue={(option) => option.label}
                  label="Country"
                  options={countries}
                  placeholder="Select a country"
                  searchPlaceholder="Search country..."
                />
              )}
            </form.AppField>

            <form.AppField
              name="state"
              validators={{
                onBlur: detailsIntelSchema.shape.state,
              }}
            >
              {(field) => (
                <form.Subscribe selector={(state) => state.values.country}>
                  {(country) =>
                    country === DEFAULT_COUNTRY ? (
                      <field.SelectField
                        className="w-full"
                        label="State"
                        options={stateOptions}
                        placeholder="Select a state"
                      />
                    ) : (
                      <field.TextField
                        label="Province"
                        placeholder="Enter state/province"
                        type="text"
                      />
                    )
                  }
                </form.Subscribe>
              )}
            </form.AppField>

            <form.AppField
              name="city"
              validators={{
                onBlur: detailsIntelSchema.shape.city,
              }}
            >
              {(field) => (
                <field.TextField
                  autoComplete="off"
                  data-1p-ignore
                  label="City"
                  placeholder="San Antonio"
                  type="text"
                />
              )}
            </form.AppField>
          </div>
        </div>
      </form.AppForm>
    );
  },
});
